import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {
  Link,
  LinkIcon,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsGff.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsGff extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {}
  }

  render() {
    const iconGm = require( '../../../static/images/icn-gm-black.svg' )
    const iconGr = require( '../../../static/images/icn-gr-black.svg' )

    return <div styleName='family-modal'>
      <div styleName='icon-row'>
        {
          this.props.company.is_gm ?
            <CompanyIsFlag icon={iconGm} title='Gun manufacturer'/> :
            null
        }
        {
          this.props.company.is_gr ?
            <CompanyIsFlag icon={iconGr} title='Gun retailer'/> :
            null
        }
      </div>

    </div>
  }
}

